import { render } from "./doodleboard.vue?vue&type=template&id=240a628d"
import script from "./doodleboard.vue?vue&type=script&lang=js"
export * from "./doodleboard.vue?vue&type=script&lang=js"

import "./doodleboard.vue?vue&type=style&index=0&id=240a628d&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__